import * as React from "react";
import { _MasterDetailView, } from "../generic/master-detail-view/MasterDetailView";
import { DetailViewLibrary } from "./DetailViewLibrary";
import { MasterViewLibrary } from "./MasterViewLibrary";
export var TabFarm = function () {
    var MasterDetailView = _MasterDetailView;
    return (React.createElement(MasterDetailView, { masterRenderer: MasterViewLibrary, detailRenderer: DetailViewLibrary }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/library/TabFarm.tsx
// module id = 2687
// module chunks = 3